import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center px-6 text-[#333] md:pt-10 pt-[73px] h-auto">
            {/* Section 1 */}
            <h1 className="md:text-5xl text-4xl md:text-6xl font-light mb-10">{t("legal.privacy.title")}</h1>
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.coversTitle")}</h2>
                <p className='text-[17px]'>
                    {t("legal.privacy.coversBody")}
                </p>
            </div>
            {/* Section 2 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.collectTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p className="font-semibold">{t("legal.privacy.provideTitle")}</p>
                        <p>{t("legal.privacy.provideBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.accountTitle")}</p>
                        <p>
                            {t("legal.privacy.accountBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.contentTitle")}</p>
                        <p>
                            {t("legal.privacy.contentBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.websiteTitle")}</p>
                        <p>
                            {t("legal.privacy.websiteBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.paymentTitle")}</p>
                        <p>
                            {t("legal.privacy.paymentBody")}
                        </p>
                    </div>
                </div>
            </div>
            {/* Section 3 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.autoCollectTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.autoCollectIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.serviceUsageTitle")}</p>
                        <p>
                            {t("legal.privacy.serviceUsageBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.deviceConnectionTitle")}</p>
                        <p>
                            {t("legal.privacy.deviceConnectionBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.cookiesTrackingTitle")}</p>
                        <p>
                            {t("legal.privacy.cookiesTrackingBody")}
                        </p>
                    </div>
                </div>
            </div>
            {/* Section 4 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.otherSourcesTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.otherSourcesIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.otherUsersInfoTitle")}</p>
                        <p>
                            {t("legal.privacy.otherUsersInfoBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.linkedServicesTitle")}</p>
                        <p>
                            {t("legal.privacy.linkedServicesBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.affiliatesPartnersTitle")}</p>
                        <p>
                            {t("legal.privacy.affiliatesPartnersBody")}
                        </p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.otherPartnersProvidersTitle")}</p>
                        <p>
                            {t("legal.privacy.otherPartnersProvidersBody")}
                        </p>
                    </div>
                </div>
            </div>
            {/* Section 5 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.useHowTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    {t("legal.privacy.useHowIntro") ? (
                        <div>
                            <p>{t("legal.privacy.useHowIntro")}</p>
                        </div>
                    ) : null}
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useDeliverPersonalizeTitle")}</p>
                        <p>{t("legal.privacy.useDeliverPersonalizeBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useCollaborationTitle")}</p>
                        <p>{t("legal.privacy.useCollaborationBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useSeamlessEcosystemTitle")}</p>
                        <p>{t("legal.privacy.useSeamlessEcosystemBody")}</p>
                    </div>
                    <div>
                        <p>{t("legal.privacy.useOptOutPersonalized")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useResearchDevTitle")}</p>
                        <p>{t("legal.privacy.useResearchDevBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useServiceCommunicationsTitle")}</p>
                        <p>{t("legal.privacy.useServiceCommunicationsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useMarketingTitle")}</p>
                        <p>{t("legal.privacy.useMarketingBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useCustomerSupportTitle")}</p>
                        <p>{t("legal.privacy.useCustomerSupportBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useSafetySecurityTitle")}</p>
                        <p>{t("legal.privacy.useSafetySecurityBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useLegalBusinessTitle")}</p>
                        <p>{t("legal.privacy.useLegalBusinessBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useWithConsentTitle")}</p>
                        <p>{t("legal.privacy.useWithConsentBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.useEeaLegalBasisTitle")}</p>
                        <p>{t("legal.privacy.useEeaLegalBasisIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.useEeaLi1")}</li>
                            <li>{t("legal.privacy.useEeaLi2")}</li>
                            <li>{t("legal.privacy.useEeaLi3")}</li>
                            <li>{t("legal.privacy.useEeaLi4")}</li>
                        </ul>
                        <p>{t("legal.privacy.useEeaNote")}</p>
                    </div>
                </div>
            </div>
            {/* Section 6 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.shareHowTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.shareIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareOtherUsersTitle")}</p>
                        <p>{t("legal.privacy.shareOtherUsersBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareManagedAccountsTitle")}</p>
                        <p>{t("legal.privacy.shareManagedAccountsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareCommunityForumsTitle")}</p>
                        <p>{t("legal.privacy.shareCommunityForumsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareDisclosureThirdPartiesTitle")}</p>
                        <p>{t("legal.privacy.shareDisclosureThirdPartiesBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareServiceProvidersTitle")}</p>
                        <p>{t("legal.privacy.shareServiceProvidersBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sharePartnersConsultantsTitle")}</p>
                        <p>{t("legal.privacy.sharePartnersConsultantsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareThirdPartyAppsTitle")}</p>
                        <p>{t("legal.privacy.shareThirdPartyAppsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareLinksWidgetsTitle")}</p>
                        <p>{t("legal.privacy.shareLinksWidgetsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareWithConsentTitle")}</p>
                        <p>{t("legal.privacy.shareWithConsentBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.shareLegalComplianceTitle")}</p>
                        <p>{t("legal.privacy.shareLegalComplianceIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.shareLegalComplianceLi1")}</li>
                            <li>{t("legal.privacy.shareLegalComplianceLi2")}</li>
                            <li>{t("legal.privacy.shareLegalComplianceLi3")}</li>
                            <li>{t("legal.privacy.shareLegalComplianceLi4")}</li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* Section 7 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.affiliateDisclosureTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.affiliateDisclosureIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.affiliateUbEntitiesTitle")}</p>
                        <p>{t("legal.privacy.affiliateUbEntitiesBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.affiliateBusinessTransfersTitle")}</p>
                        <p>{t("legal.privacy.affiliateBusinessTransfersBody")}</p>
                    </div>
                </div>
            </div>

            {/* Section 8 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.storeSecureTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.storeSecureIntroBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.storeSecureServerTitle")}</p>
                        <p>{t("legal.privacy.storeSecureServerIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.storeSecureServerLi1")}</li>
                            <li>{t("legal.privacy.storeSecureServerLi2")}</li>
                            <li>{t("legal.privacy.storeSecureServerLi3")}</li>
                        </ul>
                        <p>{t("legal.privacy.storeSecureServerFooter")}</p>
                    </div>
                </div>
            </div>

            {/* Section 9 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.retentionTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.retentionIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.retentionAccountTitle")}</p>
                        <p>{t("legal.privacy.retentionAccountLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.retentionAccountLi1")}</li>
                            <li>{t("legal.privacy.retentionAccountLi2")}</li>
                            <li>{t("legal.privacy.retentionAccountLi3")}</li>
                        </ul>
                        <p>{t("legal.privacy.retentionAccountFooter")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.retentionSharedTitle")}</p>
                        <p>{t("legal.privacy.retentionSharedBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.retentionManagedTitle")}</p>
                        <p>{t("legal.privacy.retentionManagedBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.retentionMarketingTitle")}</p>
                        <p>{t("legal.privacy.retentionMarketingIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.retentionMarketingLi1")}</li>
                            <li>{t("legal.privacy.retentionMarketingLi2")}</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Section 10 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.accessControlTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.accessControlIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.accessRightsTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.accessRightsLi1")}</li>
                            <li>{t("legal.privacy.accessRightsLi2")}</li>
                            <li>{t("legal.privacy.accessRightsLi3")}</li>
                            <li>{t("legal.privacy.accessRightsLi4")}</li>
                            <li>{t("legal.privacy.accessRightsLi5")}</li>
                            <li>{t("legal.privacy.accessRightsLi6")}</li>
                            <li>{t("legal.privacy.accessRightsLi7")}</li>
                            <li>{t("legal.privacy.accessRightsLi8")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.accessExerciseTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.accessExerciseLi1")}</li>
                            <li>{t("legal.privacy.accessExerciseLi2")}</li>
                            <li>{t("legal.privacy.accessExerciseLi3")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.accessLimitationsTitle")}</p>
                        <p>{t("legal.privacy.accessLimitationsBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.accessComplaintsTitle")}</p>
                        <p>{t("legal.privacy.accessComplaintsBody")}</p>
                    </div>
                </div>
            </div>
            {/* Section 11 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.manageInfoTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.manageInfoIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.manageAccessUpdateTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.manageAccessUpdateLi1")}</li>
                            <li>{t("legal.privacy.manageAccessUpdateLi2")}</li>
                            <li>{t("legal.privacy.manageAccessUpdateLi3")}</li>
                            <li>
                                {t("legal.privacy.manageAccessUpdateDocsIntro")}
                                <ul className="list-disc list-inside ml-6 mt-1">
                                    <li>{t("legal.privacy.manageAccessUpdateDoc1")}</li>
                                    <li>{t("legal.privacy.manageAccessUpdateDoc2")}</li>
                                    <li>{t("legal.privacy.manageAccessUpdateDoc3")}</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.manageDeactivateTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.manageDeactivateLi1")}</li>
                            <li>{t("legal.privacy.manageDeactivateLi2")}</li>
                            <li>{t("legal.privacy.manageDeactivateLi3")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.manageDeleteTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.manageDeleteLi1")}</li>
                            <li>{t("legal.privacy.manageDeleteLi2")}</li>
                            <li>
                                {t("legal.privacy.manageDeleteRetainIntro")}
                                <ul className="list-disc list-inside ml-6 mt-1">
                                    <li>{t("legal.privacy.manageDeleteRetainLi1")}</li>
                                    <li>{t("legal.privacy.manageDeleteRetainLi2")}</li>
                                    <li>{t("legal.privacy.manageDeleteRetainLi3")}</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* Section 12 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.stopUseTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.stopUseIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.stopUseRightsTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.stopUseRightsLi1")}</li>
                            <li>{t("legal.privacy.stopUseRightsLi2")}</li>
                            <li>{t("legal.privacy.stopUseRightsLi3")}</li>
                            <li>{t("legal.privacy.stopUseRightsLi4")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.stopUseOptOutTitle")}</p>
                        <p>{t("legal.privacy.stopUseOptOutIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.stopUseOptOutLi1")}</li>
                            <li>{t("legal.privacy.stopUseOptOutLi2")}</li>
                            <li>{t("legal.privacy.stopUseOptOutLi3")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.stopUseNewUsesFooter")}</p>
                    </div>
                </div>
            </div>
            {/* Section 13 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.targetedAdsTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p className="font-semibold">{t("legal.privacy.targetedAdsLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.targetedAdsLi1")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.trackingPrefsTitle")}</p>
                        <p>{t("legal.privacy.trackingPrefsIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.dntTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.dntLi1")}</li>
                            <li>{t("legal.privacy.dntLi2")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.gpcTitle")}</p>
                        <p>{t("legal.privacy.gpcIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.gpcLi1")}</li>
                            <li>{t("legal.privacy.gpcLi2")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.gpcLearnMore")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.additionalControlsTitle")}</p>
                        <p>{t("legal.privacy.additionalControlsIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.additionalControlsLi1")}</li>
                            <li>{t("legal.privacy.additionalControlsLi2")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.dataPortabilityTitle")}</p>
                        <p>{t("legal.privacy.dataPortabilityBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.dataPortabilityRequestTitle")}</p>
                        <p>{t("legal.privacy.dataPortabilityRequestLead")}</p>
                        <ul className="list-disc list-inside ml-4">
                            <li>{t("legal.privacy.dataPortabilityRequestLi1")}</li>
                            <li>{t("legal.privacy.dataPortabilityRequestLi2")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.dataPortabilityNote")}</p>
                    </div>
                </div>
            </div>
            {/* Section 14 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.intlTransferTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.intlTransferIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.intlInternalTitle")}</p>
                        <p>{t("legal.privacy.intlInternalBody")}</p>
                        <p className="font-semibold mt-2">{t("legal.privacy.intlSafeguardLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.intlSafeguardLi1")}</li>
                            <li>{t("legal.privacy.intlSafeguardLi2")}</li>
                            <li>{t("legal.privacy.intlSafeguardLi3")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.intlThirdPartyTitle")}</p>
                        <p>{t("legal.privacy.intlThirdPartyIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.intlThirdPartyLi1")}</li>
                            <li>{t("legal.privacy.intlThirdPartyLi2")}</li>
                            <li>{t("legal.privacy.intlThirdPartyLi3")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.intlFrameworkTitle")}</p>
                        <p>{t("legal.privacy.intlFrameworkIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.intlFrameworkLi1")}</li>
                            <li>{t("legal.privacy.intlFrameworkLi2")}</li>
                            <li>{t("legal.privacy.intlFrameworkLi3")}</li>
                            <li>{t("legal.privacy.intlFrameworkLi4")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.intlDisputeTitle")}</p>
                        <p>{t("legal.privacy.intlDisputeIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.intlDisputeLi1")}</li>
                            <li>{t("legal.privacy.intlDisputeLi2")}</li>
                            <li>{t("legal.privacy.intlDisputeLi3")}</li>
                            <li>{t("legal.privacy.intlDisputeLi4")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.intlLegalTitle")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.intlLegalLi1")}</li>
                            <li>{t("legal.privacy.intlLegalLi2")}</li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* Section 15 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.otherPrivacyTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p className="font-semibold">{t("legal.privacy.endUserNoticeTitle")}</p>
                        <p>{t("legal.privacy.endUserNoticeBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.adminPowersTitle")}</p>
                        <p>{t("legal.privacy.adminPowersLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.adminPowersLi1")}</li>
                            <li>{t("legal.privacy.adminPowersLi2")}</li>
                            <li>{t("legal.privacy.adminPowersLi3")}</li>
                            <li>{t("legal.privacy.adminPowersLi4")}</li>
                            <li>{t("legal.privacy.adminPowersLi5")}</li>
                            <li>{t("legal.privacy.adminPowersLi6")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.orgEmailTitle")}</p>
                        <p>{t("legal.privacy.orgEmailBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.retainControlTitle")}</p>
                        <p>{t("legal.privacy.retainControlLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.retainControlLi1")}</li>
                            <li>{t("legal.privacy.retainControlLi2")}</li>
                            <li>{t("legal.privacy.retainControlLi3")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.retainControlNote")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.needHelpTitle")}</p>
                        <p>{t("legal.privacy.needHelpBody")}</p>
                    </div>
                </div>
            </div>

            {/* Section 16 */}
            <div className='space-y-4 mb-4 w-full'>
                <h2 className="text-[#3A57FF] font-medium text-[26px]">{t("legal.privacy.sensitiveInfoTitle")}</h2>
                <div className="space-y-4 text-[17px]">
                    <div>
                        <p>{t("legal.privacy.sensitiveInfoIntro")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sensitiveRetentionTitle")}</p>
                        <p>{t("legal.privacy.sensitiveRetentionLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.sensitiveRetentionLi1")}</li>
                            <li>{t("legal.privacy.sensitiveRetentionLi2")}</li>
                            <li>{t("legal.privacy.sensitiveRetentionLi3")}</li>
                            <li>{t("legal.privacy.sensitiveRetentionLi4")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.sensitiveRetentionRef")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sensitiveRightsTitle")}</p>
                        <p>{t("legal.privacy.sensitiveRightsIntro")}</p>
                        <p>{t("legal.privacy.sensitiveRightsLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.sensitiveRightsLi1")}</li>
                            <li>{t("legal.privacy.sensitiveRightsLi2")}</li>
                            <li>{t("legal.privacy.sensitiveRightsLi3")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.sensitiveRightsRef")}</p>
                        <p className="mt-2">{t("legal.privacy.sensitiveRightsVerification")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sensitiveOptOutTitle")}</p>
                        <p>{t("legal.privacy.sensitiveOptOutIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.sensitiveOptOutLi1")}</li>
                            <li>{t("legal.privacy.sensitiveOptOutLi2")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.sensitiveOptOutHowIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.sensitiveOptOutHowLi1")}</li>
                            <li>{t("legal.privacy.sensitiveOptOutHowLi2")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.sensitiveOptOutUnder16")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sensitiveAgentTitle")}</p>
                        <p>{t("legal.privacy.sensitiveAgentIntro")}</p>
                        <p>{t("legal.privacy.sensitiveAgentLead")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.sensitiveAgentLi1")}</li>
                            <li>{t("legal.privacy.sensitiveAgentLi2")}</li>
                            <li>{t("legal.privacy.sensitiveAgentLi3")}</li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sensitiveChildrenTitle")}</p>
                        <p>{t("legal.privacy.sensitiveChildrenBody")}</p>
                    </div>
                    <div>
                        <p className="font-semibold">{t("legal.privacy.sensitiveChangesTitle")}</p>
                        <p>{t("legal.privacy.sensitiveChangesIntro")}</p>
                        <ul className="list-disc list-inside">
                            <li>{t("legal.privacy.sensitiveChangesLi1")}</li>
                            <li>{t("legal.privacy.sensitiveChangesLi2")}</li>
                            <li>{t("legal.privacy.sensitiveChangesLi3")}</li>
                        </ul>
                        <p className="mt-2">{t("legal.privacy.sensitiveChangesFooter")}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
